Ext.define('SA.RankingViewController', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.observable = new Ext.util.Observable();

        this.toolbar = new SA.view.RankingToolbar({model, filteringMenuCfg: {xtype: 'filters-window', projectView: model}});
        this.view = Ext.widget({xtype: 'ranking-grid', projectView: model});
        this.projectView = SA.ProjectView.createHidden(this.view);

        this.initEvents();
    },

    initEvents() {
        this.activeState.onActive(this.onActive, this);

        this.observable.mon(SA.data.LocationAliases, 'change', this.refreshToolbar, this);

        this.observable.mon(this.model.getProject(), 'change:location', this.refreshToolbar, this);
        this.observable.mon(this.model.getProject(), 'change:unitDiscoverable', this.refreshToolbar, this);

        this.model.on('remove', this.onModelDelete, this);
        this.model.on('change:attribute', this.refreshToolbar, this);
        this.model.on('change:filter', this.refreshToolbar, this);
        this.model.on('change:filterVisibility', this.refreshToolbar, this);
        this.model.on('change:geographicUnit', this.refreshToolbar, this);
        this.model.on('change:location', this.refreshToolbar, this);
        this.model.on('change:maximumChildren', this.refreshToolbar, this);
        this.model.on('change:sort', this.refreshToolbar, this);

        this.toolbar.on('change:location', this.onLocationDropdownChange, this);
        this.toolbar.on('change:sort', this.onSortComboChange, this);
        this.toolbar.on('change:topN', this.onTopNComboChange, this);
        this.toolbar.on('change:unit', this.onUnitComboChange, this);
        this.toolbar.on('activate:exportBtn', this.onActivateExportBtn, this);
    },

    onActivateExportBtn(button) {
        var maxChildren = this.model.getMaximumChildren(),
            menuItems = [{
                text: `Export Top ${maxChildren} Rows`,
                handler: () => this.onExportMenuItemClick(maxChildren),
                hidden: !this.model.isReportDataLoading() && !this.model.hasMoreResultsAvailableThanDisplayed()
            }, {
                text: 'Export All Rows',
                handler: () => this.onExportMenuItemClick()
            }];

        button.setMenuCfg({xtype: 'menu', items: menuItems});
        button.showMenu();
    },

    onActive() {
        SA.ProjectViewToolbar.setToolbar(this.toolbar);
        SA.ProjectView.show(this.projectView);

        this.refreshToolbar();
    },

    onExportMenuItemClick(maximumChildren = null) {
        Ext.widget({xtype: 'export-window', config: new SA.RankingExportConfig({maximumChildren, model: this.model})});
    },

    onLocationDropdownChange(location) {
        location = SA.data.LocationsCache.toLocationSeries(location);

        this.model.addLocation(location);
        this.model.save();

        SA.data.RecentLocations.add(location);
    },

    onModelDelete() {
        this.toolbar.destroy();
        this.projectView.destroy();
        this.observable.clearListeners();
    },

    onSortComboChange(attribute) {
        this.model.setSort(attribute?.attribute ?? 'name');
        this.model.save();
    },

    onTopNComboChange(value) {
        this.model.setMaximumChildren(value);
        this.model.save();
    },

    onUnitComboChange(unit) {
        this.model.setGeographicUnit(unit);
        this.model.save();
    },

    refreshToolbar() {
        if (!this.activeState.isActive()) {
            return;
        }

        var sortAttribute = this.model.getSortAttribute();

        this.toolbar.setState({
            topNValue: this.model.getMaximumChildren(),
            unitItems: this.model.getAllowedGeographicUnits(),
            unitValue: this.model.getGeographicUnit(),
            locationItems: SA.data.LocationsCache.get(this.model.getProject().getLocations()),
            locationValue: SA.data.LocationsCache.get(this.model.getLocation()),
            sortItems: [null, '-', ...SA.data.AttributesCache.get(this.model.getAttributes())],
            sortValue: sortAttribute === 'name' ? null : SA.data.AttributesCache.get(sortAttribute),
            filtered: this.model.isFiltered()
        });
    }
});